import React, { useState, useEffect } from 'react';
import Button from '@mui/material/Button';
import { useForm, Controller } from 'react-hook-form';
import {
  FormControl,
  Grid,
  FormLabel,
  Select,
  RadioGroup,
  FormControlLabel,
  Radio,
  InputLabel,
  TextField,
  Checkbox,
  MenuItem,
  Box,
  Typography,
  Paper,
  alpha,
} from '@mui/material';
import Autocomplete from '@mui/material/Autocomplete';
import Swal from 'sweetalert2';
import { useTheme } from '@mui/material/styles';

import { Modal } from '../../../components/BootstrapToMUI';
import request from '../../../services/Request';

import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

export default function AddShoppingCartModal(props) {
  const theme = useTheme();
  const { data, setReflesh, reflesh, id, setMobile, ...rest } = props;
  const defaultValues = {
    machine: data?.add_to_cart?.machine?._id ? data.add_to_cart.machine : null,
    prods: data?.add_to_cart?.products?.length > 0 ? data?.add_to_cart.products : [],
  };
  const { handleSubmit, reset, watch, control, register, setValue } = useForm({ defaultValues });

  const watchAll = watch();

  const [machines, setMachines] = useState([]);
  const [products, setProducts] = useState([]);

  useEffect(() => {
    if (props.show) {
      request({
        method: 'post',
        url: `/machines/getMachineSelect`,
        data: {
          email: id,
          select: 'member',
        },
      })
        .then((res) => {
          console.log('machines', res.data);
          setMachines(res.data);
          // setProducts(res.data);
        })
        .catch((err) => {
          setMachines([]);
          Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: err?.response?.data?.message || `download machines error`,
          });
        })
        .finally(() => {
          console.log('defaultValues', defaultValues);
          reset(defaultValues);
        });
    }
  }, [props.show]);

  useEffect(() => {
    const findindex = machines.findIndex((e) => e._id === watchAll?.machine?._id);
    console.log('findindex', machines[findindex]);
    let uniqueProducts = [];
    if (findindex >= 0) {
      let pdArray = machines[findindex].product;
      let bundleArray = machines[findindex].products_bundle;
      if (bundleArray?.length > 0) {
        bundleArray = bundleArray.map((bd) => {
          return {
            id: bd,
          };
        });
      }

      let productArray = [...pdArray, ...bundleArray];

      if (productArray?.length > 0) {
        uniqueProducts = Array.from(new Set(productArray.map((p) => p.id._id))).map((id) =>
          productArray.find((p) => p.id._id === id)
        );
      }
    }
    //filter same products
    setProducts(uniqueProducts);
    // console.log('watall.machine', watchAll?.machine);
    // console.log('data?.add_to_cart?.machine', data?.add_to_cart?.machine);
    if (watchAll?.machine?._id !== data?.add_to_cart?.machine?._id) {
      setValue('prods', []);
    }
  }, [watchAll?.machine]);

  const onSubmit = async (formData) => {
    let prods = [];
    if (formData.prods.length > 0) {
      prods = formData.prods.map((p) => {
        return {
          id: p.id,
        };
      });
    }

    if (formData.machine === null) {
      prods = [];
    }

    const _id = data?._id ? data?._id : id;
    const isAll = data?._id ? false : true;

    //check is product contain bundles
    console.log('prods', prods);
    if (prods?.length > 1) {
      let isBundle = false;
      prods.forEach((p) => {
        if (p?.id?.prodType === 'bundle') {
          isBundle = true;
        }
      });
      if (isBundle) {
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'You can not add 1 bundle to cart',
        });
        return;
      }
    }

    request({
      method: 'post',
      url: `/clientUser/clientUserAddToCart`,
      data: {
        _id: _id,
        machine: formData.machine,
        products: prods,
        isAll: isAll,
        created_by_admin: true,
      },
    })
      .then(() => {
        Swal.fire({
          icon: 'success',
          title: 'Success',
          text: 'Product added to cart',
        }).then(() => {
          setReflesh(!reflesh);
          props.onHide();
        });
      })
      .catch((err) => {
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: err?.response?.data?.message || `add to cart error`,
        });
      });
    console.log('formData', formData);
    console.log('rowdata,', data);
  };

  return (
    <Modal className="modal-w" {...rest} centered size="md">
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Add Product To Member {data?.username ? data.username : '(ALL)'}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="modal-body">
        <Box sx={{ px: 2, py: 1 }}>
          <form onSubmit={handleSubmit(onSubmit)} noValidate>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
              {/* Machine Selection */}
              <Paper
                elevation={0}
                sx={{
                  p: 2,
                  backgroundColor: alpha(theme.palette.primary.main, 0.03),
                  borderRadius: 1.5,
                  border: `1px solid ${alpha(theme.palette.primary.main, 0.1)}`,
                }}
              >
                <Typography
                  variant="caption"
                  sx={{
                    fontWeight: 600,
                    mb: 1.5,
                    display: 'block',
                    color: theme.palette.text.secondary,
                    fontSize: '0.8rem',
                  }}
                >
                  Select Machine
                </Typography>
                <Controller
                  name="machine"
                  control={control}
                  render={({ field }) => (
                    <Autocomplete
                      options={machines}
                      value={watchAll.machine}
                      onChange={(event, value) => {
                        field.onChange(value);
                      }}
                      isOptionEqualToValue={(option, value) => option.name === value.name}
                      getOptionLabel={(option) => option.name + ' (' + option.description + ')'}
                      renderOption={(props, option, { selected }) => (
                        <li {...props}>
                          <Checkbox
                            icon={icon}
                            checkedIcon={checkedIcon}
                            style={{ marginRight: 8 }}
                            checked={selected}
                            size="small"
                          />
                          {option.name + ' (' + option.description + ')'}
                        </li>
                      )}
                      fullWidth
                      renderInput={(params) => (
                        <TextField {...params} variant="outlined" label="Machine" size="small" />
                      )}
                    />
                  )}
                />
              </Paper>

              {/* Products Selection */}
              {products?.length > 0 && (
                <Paper
                  elevation={0}
                  sx={{
                    p: 2,
                    backgroundColor: alpha(theme.palette.secondary.main, 0.03),
                    borderRadius: 1.5,
                    border: `1px solid ${alpha(theme.palette.secondary.main, 0.1)}`,
                  }}
                >
                  <Typography
                    variant="caption"
                    sx={{
                      fontWeight: 600,
                      mb: 1.5,
                      display: 'block',
                      color: theme.palette.text.secondary,
                      fontSize: '0.8rem',
                    }}
                  >
                    Select Products (Max 3)
                  </Typography>
                  <Controller
                    name="prods"
                    control={control}
                    render={({ field }) => (
                      <Autocomplete
                        multiple
                        options={products}
                        value={watchAll.prods || []}
                        disableCloseOnSelect
                        onChange={(event, value, reason) => {
                          if (reason === 'select-option') {
                            const newValue = [...watchAll.prods, value[value.length - 1]];

                            if (newValue.length > 3) {
                              Swal.fire({
                                icon: 'error',
                                title: 'Oops...',
                                text: 'You can add only 3 products',
                              });
                            } else {
                              field.onChange(newValue);
                            }
                          } else if (reason === 'remove-option') {
                            field.onChange(value);
                          }
                        }}
                        isOptionEqualToValue={() => false}
                        getOptionLabel={(option) => option.id?.name?.en}
                        renderOption={(props, option) => (
                          <li {...props}>{option.id?.name?.en + ' (' + option.id?.upc + ')'}</li>
                        )}
                        fullWidth
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            variant="outlined"
                            label="Add Products"
                            size="small"
                          />
                        )}
                      />
                    )}
                  />
                </Paper>
              )}

              {/* Submit Button */}
              <Button
                variant="contained"
                color="primary"
                type="submit"
                fullWidth
                sx={{ mt: 1, py: 1 }}
              >
                Submit
              </Button>
            </Box>
          </form>
        </Box>
      </Modal.Body>
    </Modal>
  );
}
